export class StatusBarTarget {
  public static readonly ORDER_LINES = 'order-book/order-lines';
  public static readonly DRAWING_LIBRARY = 'drawings';
}
